export default "__VITE_ASSET__DyqBeWKY__"